import PropTypes from 'prop-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Image from '../../../Core/Image';
import Link from '../../../Core/Link';

import { TitleContainer, TitleCopy, TitleBody, BodyContent } from './styles';

const title = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <TitleCopy>{children}</TitleCopy>,
    [BLOCKS.HEADING_1]: (_, children) => <TitleCopy>{children}</TitleCopy>,
    [BLOCKS.HEADING_2]: (_, children) => <TitleCopy>{children}</TitleCopy>,
    [BLOCKS.HEADING_3]: (_, children) => <TitleCopy>{children}</TitleCopy>,
  },
};

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <TitleBody>{children}</TitleBody>,
    [INLINES.HYPERLINK]: (node, children) => {
      const { data: linkCta } = node;
      return (
        <Link className="rich-text-link" to={linkCta.uri} fontSize="inherit">
          {children}
        </Link>
      );
    },
  },
};

const ImageTitle = ({ data, theme = '' }) => {
  if (!data) return null;

  const { heading, headingColor, imageDam, bodyCopy, textAlignment } = data;

  return (
    <TitleContainer
      headingColor={headingColor}
      className={theme}
      textAlignment={textAlignment}
    >
      {imageDam && <Image src={imageDam} alt="" role="presentation" />}
      {heading && <RichText document={heading} options={title} />}
      {bodyCopy && (
        <BodyContent textAlignment={textAlignment}>
          <RichText document={bodyCopy} options={body} />
        </BodyContent>
      )}
    </TitleContainer>
  );
};

ImageTitle.propTypes = {
  data: PropTypes.shape().isRequired,
  theme: PropTypes.string,
};

export default ImageTitle;
